// DOM ready bind - execute all pending delegate/static functions
mpro.init({ now: true });
